// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  offboarding_url: 'https://anet-staging.agiratech.com/api/v2',
  api_url: 'https://smart-api-staging.busofttech.com',
  skill_matrix_api: 'https://smart-api-staging.busofttech.com/njs/asm/api/v1/',
  blog_url: 'https://agira-blog-management-stage.herokuapp.com/',
  rim_url: 'https://smart-staging.busofttech.com/api/v2/',
  ahr_url: 'https://hire-staging.busofttech.com',
  google_login_client_id: '804052763086-leqfgpv7tj7iti7uruqsk27jc1nn9nf5.apps.googleusercontent.com',
  microsoft_login_client_id: '9b19d08b-b70d-43c1-a036-9c50b9912fdc',
  microsoft_tenant_id: '6e4f0923-3eb0-454d-92df-cb8d5a21487b',
  project_url: 'https://project.busofttech.com/',
  hire_url: 'https://hire.busofttech.com/',
  Quarters: [
    {
      'key': 'Quarter1',
      'value': 'Quarter1 (April - June)',
      'start_date': '2020-04-01',
      'end_date': '2020-06-30'
    },
    {
      'key': 'Quarter2',
      'value': 'Quarter2 (July - September)',
      'start_date': '2020-07-01',
      'end_date': '2020-09-30'
    },
    {
      'key': 'Quarter3',
      'value': 'Quarter3 (October - December)',
      'start_date': '2020-10-01',
      'end_date': '2020-12-31'
    },
    {
      'key': 'Quarter4',
      'value': 'Quarter4 (January - March)',
      'start_date': '2021-01-01',
      'end_date': '2021-03-31'
    }
  ],
  Half_yearly: [
    {
      'key': 'First Half',
      'value': 'First Half (April - September)'
    },
    {
      'key': 'Second Half',
      'value': 'Second Half (October - March)'
    }
  ],
  Yearly: [
    {
      'key': 'Full Year',
      'value': 'Full Year (April - March)'
    }
  ],
  Month: [
    {
      'key': 'April',
      'value': 'April'
    }, {
      'key': 'May',
      'value': 'May'
    }, {
      'key': 'June',
      'value': 'June'
    }, {
      'key': 'July',
      'value': 'July'
    }, {
      'key': 'August',
      'value': 'August'
    }, {
      'key': 'September',
      'value': 'September'
    }, {
      'key': 'October',
      'value': 'October'
    }, {
      'key': 'November',
      'value': 'November'
    }, {
      'key': 'December',
      'value': 'December'
    }, {
      'key': 'January',
      'value': 'January'
    },
    {
      'key': 'Feburary',
      'value': 'Feburary'
    }, {
      'key': 'March',
      'value': 'March'
    }
  ]
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/environments/environment.ts